import { Container } from '@cp/ui';
import React from 'react';
import { Helmet } from 'react-helmet';
import { HttpStatusCode } from '@cp/utils/const/httpStatusCode';
import { Link } from '@cp/ds/src/components/link';
import { IReactAppError } from '@common/model/reactApp/error';
import { Exception } from 'src/shared/ui/exception';
import { SupportCode } from 'src/shared/supportCode';
import { useStaticRouterContext } from '../../shared/context/staticRouterContext/context';

const ExceptionPage: React.FC<{ error?: IReactAppError }> = ({ error }) => {
  const staticRouterContext = useStaticRouterContext();

  if (staticRouterContext) {
    staticRouterContext.statusCode = HttpStatusCode.InternalServerError;
  }

  return (
    <div>
      <Helmet>
        <title>Ошибка сервиса</title>
      </Helmet>
      <Container>
        <Exception
          error={error instanceof Error ? error : undefined}
          nextAction={
            <Link external href="/" sx={{ textAlign: 'center' }} target="_self">
              Обновить страницу
            </Link>
          }
          sx={{ my: { xs: 4, md: 18 } }}
        >
          <SupportCode sx={{ textAlign: 'center' }} />
        </Exception>
      </Container>
    </div>
  );
};

export default ExceptionPage;
